import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@heroui/react"

import { QuestionMarkCircleIcon } from "@heroicons/react/20/solid"

import PropTypes from "prop-types"

const HelpPopOver = ({ 
  id, 
  children, 
  color = "text-content3", 
  hoverColor = "text-content4",
}) => (
  <Popover key={id} placement="top">
    <PopoverTrigger>
      <QuestionMarkCircleIcon className={`w-6 h-6 ${color} hover:${hoverColor} hover:cursor-pointer`} />
    </PopoverTrigger>
  
    <PopoverContent className={`p-5 bg-indigo-900 text-white`}>
      {children}
    </PopoverContent>
  </Popover>
)

HelpPopOver.propTypes = {
  alignment: PropTypes.string,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  id: PropTypes.string.isRequired,
  hoverColor: PropTypes.string,
}

export default HelpPopOver